import React, { useState } from 'react'
import VideoWrapper from '../common/VideoWrapper'
import { graphql, useStaticQuery } from 'gatsby'
import ModalPopUp from '../common/ModalPopUp';

const OneOnOneClass = () => {

    const data = useStaticQuery(query);

    const { allStrapiHomeOneOnOneClass: { nodes: HomeOneOnOneClass } } = data;

  const { home_oneOnOneClass_heading, home_oneOnOneClass_video } = HomeOneOnOneClass[0];
  
  const [showVideo, setShowVideo] = useState({
    showVideo: false,
    videoUrl: null
  });
    return (
        <>
            <section className="one_on_one_main">
                <div className="one_on_one_left">
                    <h2 dangerouslySetInnerHTML={{ __html: home_oneOnOneClass_heading }} />
                </div>
                <div className="one_on_one_right">
                  <div className="desktop-one-on-one-video-wrapper">
                    <VideoWrapper ThumbnailUrl={home_oneOnOneClass_video.video_thumbnail.url} VideoUrl={home_oneOnOneClass_video.video_url} PlayBtnUrl={"https://s3.us-east-2.wasabisys.com/ufaber-lms/files/d4ebf4875b31287ca103dcf26dd860d4.svg"} VideoFunction={setShowVideo}/>
                  </div>
                  <div className="mobile-one-on-one-video-wrapper">
              <VideoWrapper ThumbnailUrl={home_oneOnOneClass_video.video_thumbnail.url} VideoUrl={home_oneOnOneClass_video.video_url} PlayBtnUrl={"https://s3.us-east-2.wasabisys.com/ufaber-lms/files/b8c8782807f308991ffa10f236e14309.svg"} VideoFunction={setShowVideo} />
                  </div>
          </div>
          {showVideo.showVideo && <ModalPopUp ShowVideo={setShowVideo} VideoLink={home_oneOnOneClass_video.video_url} />}
            </section>
        </>
    )
}

export const query = graphql`
{
    allStrapiHomeOneOnOneClass {
    nodes {
      home_oneOnOneClass_heading
      home_oneOnOneClass_video {
        video_url
        video_thumbnail {
          url
        }
      }
    }
  }
}
`

export default OneOnOneClass